module.exports = "<div class=\"card no-padding no-margin hrcl-informatic-message\">\n  <p-messages [(value)]=\"informaticMessages\" [closable]=\"false\" styleClass=\"general-message\"></p-messages>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/informatic-messages/informatic-messages.component.html
// module id = ./src/app/admission/informatic-messages/informatic-messages.component.html
// module chunks = main